import * as React from 'react';

import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Iconify from '../iconify/iconify';
import CustomPopover from './custom-popover';
import usePopover from './use-popover';

export default function ActionPopover({
  children,
  onAdd,
  onEdit,
  onShow,
  onDelete,
}: {
  children?: any;
  onAdd?: VoidFunction;
  onEdit?: VoidFunction;
  onShow?: VoidFunction;
  onDelete?: VoidFunction;
}) {
  const popover = usePopover();
  const showAction = (e: any) => {
    e.stopPropagation();
    popover.onOpen(e);
  };

  return (
    <>
      <IconButton color={popover.open ? 'inherit' : 'default'} onClickCapture={showAction}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-center"
        sx={{ width: 300 }}
      >
        {children}

        {onAdd && (
          <MenuItem onClickCapture={(e) => { e.stopPropagation(); onAdd(); }}>
            <Iconify icon="solar:pen-bold" />
            Add
          </MenuItem>
        )}

        {onShow && (
          <MenuItem onClickCapture={(e) => { e.stopPropagation(); onShow(); }}>
            <Iconify icon="solar:eye-bold" />
            Show
          </MenuItem>
        )}

        {onEdit && (
          <MenuItem onClickCapture={(e) => { e.stopPropagation(); onEdit(); }}>
            <Iconify icon="solar:pen-bold" />
            Edit
          </MenuItem>
        )}
        {onDelete && (
          <MenuItem onClickCapture={(e) => { e.stopPropagation(); onDelete(); }}>
            <Iconify sx={{ color: 'error.main' }} icon="solar:trash-bin-trash-bold" />
            Delete
          </MenuItem>
        )}
      </CustomPopover>
    </>
  );
}
